export const SEARCH_FOCUS_PARAM = 'focusInputSearch';
export const SEARCH_CLEAR_PARAM = 'cleanInputSearchContent';
export const SEARCH_ISO_CODE = 'isoCode';
export const SEARCH_CONTACT_PARAM = 'contactId';
export const SEARCH_CONTACT_INPUT_PARAM = 'contactInput';

export const AVAILABILITY_STORAGE_KEY = 'td-availability-data';
export const AVAILABILITY_UPDATE_EVENT = 'td-availability-update';
